// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.production.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://qaagent-api-uat.lgsurvey.co.uk/api', // On-premise API for development
  signalRHubUrl: 'http://localhost:5000/hubs/validation',
  azureAd: {
    clientId: 'f06de6f7-5b4d-4772-b598-0d2a891927bb', // Replace with Azure AD app client ID
    authority: 'https://login.microsoftonline.com/73d59616-ecb6-4eb8-91a3-8c498136e93d', // Replace with your tenant ID
    redirectUri: 'https://qaagent-uat.lgsurvey.co.uk',
    scopes: ['api://f06de6f7-5b4d-4772-b598-0d2a891927bb/access_as_user'], // Replace with your API scope
    // Security Group Object IDs (get from Azure AD → Groups → Object ID)
    groups: {
      admins: '202d9767-9d82-4bb8-8274-fa027c656161', // Replace with QA Agent Admins group Object ID
      users: 'bf4d1cb2-c00e-4648-ac64-efdd328fc379'    // Replace with QA Agent Users group Object ID
    }
  },
  azureOpenAI: {
    // Frontend doesn't directly call Azure OpenAI (handled by backend)
    // These are kept for reference/future use
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
